var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetirementKeep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "retirementKeep-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(218 357.063)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "retirementKeep",
    transform: "translate(-218 -357.063)",
    clipPath: "url(#retirementKeep-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.135,15.3a.915.915,0,0,0-.614-.391c-1.283,0-12.332-.446-12.332-13.281a.725.725,0,1,0-1.451,0c0,12.834-11.049,13.281-12.276,13.281a.633.633,0,0,0-.446.167c-.112.056-.167.167-.223.223a.827.827,0,0,0,0,.725.774.774,0,0,0,.67.391h.056c1.283,0,12.276.446,12.276,13.281a.725.725,0,0,0,1.451,0c0-12.778,10.993-13.281,12.276-13.281a.851.851,0,0,0,.67-.391A.686.686,0,0,0,58.135,15.3ZM44.464,24.227a12.737,12.737,0,0,0-8.7-8.593,12.737,12.737,0,0,0,8.7-8.593,12.737,12.737,0,0,0,8.7,8.593A12.737,12.737,0,0,0,44.464,24.227Z",
    transform: "translate(230.537 357.16)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.569,36.3c-.67,0-6.7-.223-6.7-7.254a.725.725,0,1,0-1.451,0c0,7.031-6.027,7.254-6.7,7.254H.67a.728.728,0,0,0-.67.725.739.739,0,0,0,.725.725c.725,0,6.7.223,6.7,7.254a.739.739,0,0,0,.725.725c.335.112.67-.223.67-.67,0-7.031,6.027-7.254,6.7-7.254h.056a.752.752,0,0,0,.725-.781A.739.739,0,0,0,15.569,36.3ZM8.091,41.042a7.668,7.668,0,0,0-4.018-3.962,7.508,7.508,0,0,0,4.018-3.962,7.484,7.484,0,0,0,4.018,3.962A7.507,7.507,0,0,0,8.091,41.042Z",
    transform: "translate(243.809 345.311)",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetirementKeep);
export default __webpack_public_path__ + "static/media/retirementKeep.b5698192621e07838d49ec65b52b58b0.svg";
export { ForwardRef as ReactComponent };